import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Observable} from 'rxjs';
import {ExamAddressResponse} from '../../../generated-client/generated-api-client';
import {ErrorProcessorService} from '../../../services/error-processor.service';
import {
  isFormModifiedDataService,
  SimpleNavigationService
} from "../../../services/data-services/navigation-data-services";

@Component({
  selector: 'app-exam-address-form',
  templateUrl: './exam-address-form.component.html',
  styleUrls: ['./exam-address-form.component.sass'],
})
export class ExamAddressFormComponent implements OnInit {
  @Input() response!: Observable<ExamAddressResponse>;
  @Output() onSubmitCallback: EventEmitter<any> = new EventEmitter();

  examAddressForm!: FormGroup;
  isLoading: boolean = true;

  constructor(
    private errorProcessorService: ErrorProcessorService,
    private _isFormModifiedDataService: isFormModifiedDataService,
    private _navigationService: SimpleNavigationService
  ) { }

  ngOnInit(): void {
    this.response?.subscribe(
      next => this.setForm(next),
      error => this.errorProcessorService.processError(error, false, true)
    );

    if (!this.response) {
      this.setForm();
    }
  }

  get id() {
    return this.examAddressForm.get('id')!;
  }

  get city() {
    return this.examAddressForm.get('city')!;
  }

  get postCode() {
    return this.examAddressForm.get('postCode')!;
  }

  get line1() {
    return this.examAddressForm.get('line1')!;
  }

  get line2() {
    return this.examAddressForm.get('line2')!;
  }

  onSubmit(): void {
    this.onSubmitCallback.emit([this.examAddressForm]);
  }

  onGoBack(path: string) {
    this._navigationService.navigateTo(path);
  }

  setForm(response?: ExamAddressResponse): void {
    this.examAddressForm = new FormGroup({
      id: new FormControl(response?.id),
      city: new FormControl(response?.city, [Validators.required, Validators.maxLength(50)]),
      postCode: new FormControl(response?.postCode, [Validators.required, Validators.pattern('^[0-9]{4}$')]),
      line1: new FormControl(response?.line1, [Validators.required, Validators.maxLength(100)]),
      line2: new FormControl(response?.line2, [Validators.maxLength(100)]),
    });
    this.errorProcessorService.formGroup = this.examAddressForm;
    this.examAddressForm.valueChanges.subscribe(() => {
      this._isFormModifiedDataService.isFormModified = true;
    });
    this.isLoading = false;
  }
}
